import type { IconComponent } from '@iheartjane/reefer';
import {
  BlissfulIcon,
  LightningIcon,
  NonImpairingIcon,
  PencilIcon,
  PizzaIcon,
  RelaxedIcon,
  RelievedIcon,
  SleepIcon,
} from '@iheartjane/reefer';

export const FEELING_ICONS: Record<string, IconComponent> = {
  Blissful: BlissfulIcon,
  Creative: PencilIcon,
  Energetic: LightningIcon,
  Hungry: PizzaIcon,
  'Not high': NonImpairingIcon,
  'Pain free': RelievedIcon,
  Relaxed: RelaxedIcon,
  Relieved: RelievedIcon,
  Sleepy: SleepIcon,
};
